import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { styleSuffix, contentSuffix, deliverySuffix, shareSuffix } from "report/ReportRoutes";
import { NavTabs } from "components/common";
const pageNavigation = (t, prefix, isCreating = false) => [
  { description: t("report_creation.overview"), path: prefix, exactPathMatch: true },
  { description: t("report_creation.content"), path: `${prefix}${contentSuffix}` },
  { description: t("report_creation.delivery"), path: `${prefix}${deliverySuffix}` },
  { description: t("report_creation.style"), path: `${prefix}${styleSuffix}` },
  ...isCreating ? [{ description: t("report_creation.share"), path: `${prefix}${shareSuffix}` }] : []
];
const ReportCreationNavigation = ({ prefix, isCreating = false }) => {
  const { t } = useTranslation("enterprise_navigation");
  const paths = useMemo(() => pageNavigation(t, prefix, isCreating), [t, prefix, isCreating]);
  return /* @__PURE__ */ React.createElement(NavTabs, { items: paths });
};
export default ReportCreationNavigation;
